<template>
  <v-app>
    <v-main class="px-0 mt-0">
      <router-view />

      <p class="version">v 1.5.2</p>
    </v-main>
  </v-app>
</template>
<script>
export default {
  name: "App",
  data: () => ({}),
  mounted() {},
};
</script>
<style lang="css">
.version {
  position: fixed;
  bottom: 5px;
  right: 10px;
  font-size: 11px;
  margin: 0 !important;
  padding: 0;
  color: aliceblue;
  font-weight: 100;
  opacity: 0.6;
}
* {
  box-sizing: border-box !important;
}
body {
  background: linear-gradient(135deg, #00adcb 20%, #0c3c60);
  font-size: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 9999;
}
.theme--light.v-application {
  background: transparent !important;
}
.sticky {
  position: sticky;
  z-index: 5;
  top: 0;
  background-color: #fff;
}
body::after {
  background-color: rgba(255, 255, 255, 0.95);
  content: "";
  height: 100%;
  position: fixed;
  inset: 0;
  clip-path: ellipse(48% 100% at 33% 69%);
  z-index: -1;
}
.v-icon::after {
  color: transparent;
}
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px white;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #00adcb;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #0c3c60;
}

.matrix-first-buttons {
  transform: scale();
}

.matrix-first-buttons:nth-child(odd):hover {
  background: linear-gradient(135deg, #00adcb 40%, #0c3c60);
  color: white;
  cursor: pointer;
}

.matrix-first-buttons:nth-child(odd):active {
  background: #00adcb;
  opacity: 0.8;
  color: white;
}

.header-text {
  font-size: 1.5rem;
  font-weight: 600;
}
@media (max-width: 960px) {
  .header-text {
    font-size: 1.2rem;
    font-weight: 600;
  }
}

.header-row {
  background: linear-gradient(135deg, #00adcb 20%, #0c3c60);
}

@media (max-width: 1279px) {
  .header-row {
    width: 95%;
  }

  .header-user-details {
    width: 95%;
  }
  .main-card {
    width: 95%;
    padding: 0.8rem;
  }
}

@media (max-width: 960px) {

  .matrix-first-buttons:nth-child(1) {
    border-radius: 4px 4px 0px 0px !important;
  }

  .matrix-first-buttons:nth-child(2) {
    border-top: 0 !important;
    border-bottom: 0 !important;
  }

  .matrix-first-buttons:nth-child(3) {
    border-bottom: 0 !important;
  }

  .matrix-first-buttons:nth-last-child(1) {
    border-radius: 0px 0px 4px 4px !important;
  }
}

@media (min-width: 1279px) {
  .header-row {
    width: 80%;
  }

  .header-user-details {
    width: 100%;
  }

  .main-card {
    width: 80%;
    padding: 0.8rem;
  }

}

@media (min-width: 960px) {
  .matrix-first-buttons {
    border-radius: 4px !important;
  }
}
</style>

